// extracted by mini-css-extract-plugin
export default {"cls1":"LockedOut-Content_cls1__BJy3A","cls2":"LockedOut-Content_cls2__taJtg LockedOut-Content_cls1__BJy3A"};